import axiosInstance from '@/utils/api.js'

var state = {
  TunnelAttributes: [],
  TunnelTypes: []
}

var getters = {
  TUNNEL_ATTRIBUTES: (state) => {
    return state.TunnelAttributes
  },
  TUNNEL_TYPES: (state) => {
    return state.TunnelTypes
  }
}

var mutations = {
  SET_TUNNEL_ATTRIBUTES: (state, payload) => {
    state.TunnelAttributes = payload
    let tmpArr = []
    payload.forEach(element => {
      tmpArr.push(element.attr_type)
    })
    state.TunnelTypes = tmpArr
  }
}

var actions = {
  GET_TUNNEL_ATTRIBUTES: async (context, payload) => {
    let result = await axiosInstance.get('/settings/attr_tunnel_types')
    if (result.status === 200) {
      context.commit('SET_TUNNEL_ATTRIBUTES', result.data)
    }
  },
  CREATE_TUNNEL_ATTRIBUTES: (context, payload) => {
    return axiosInstance.post('/settings/attr_tunnel_types', payload)
  },
  UPDATE_TUNNEL_ATTRIBUTES: (context, payload) => {
    return axiosInstance.put('/settings/attr_tunnel_types', payload)
  },
  DELETE_TUNNEL_ATTRIBUTES: (context, payload) => {
    return axiosInstance.delete('/settings/attr_tunnel_types?id=' + payload.id + '&attr_type=' + payload.attr_type)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/tunnelRadiusAttributes.js